import React from "react";
import "./Landing.css";
import michael from "../../assets/images/michael.png";
import ReactTyped from "react-typed";
import { ReactComponent as Triangle } from "../../assets/svgs/Triangle.svg";
import { navigateHandler } from "../../helpers";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const Landing = () => {
  return (
    <div id="home" className="landing">
      <motion.img
        initial={{ opacity: 0, x: "-30px" }}
        transition={{ duration: 2, delay: 1 }}
        animate={{ opacity: 1, x: 0 }}
        className="pic"
        src={michael}
        alt="Michael Quarcoo"
      />
      <div className="container-abs">
        <Triangle className="triangle" />
        <div className="text-wrapper">
          <ReactTyped
            className="salutation"
            strings={["Hey there!"]}
            typeSpeed={150}
            backDelay={20000}
            loop={true}
          />
        </div>
        <motion.div
          initial={{ opacity: 0 }}
          transition={{ delay: 2, duration: 2 }}
          animate={{ opacity: 1 }}
          className="purple"
        >
          <div className="text-wrapper">
            <ReactTyped
              className="intro"
              strings={["I'm Michael Quarcoo"]}
              typeSpeed={100}
              startDelay={3000}
              showCursor={false}
            />
            <ReactTyped
              className="title"
              strings={["A Full Stack Developer"]}
              typeSpeed={80}
              startDelay={7000}
              showCursor={false}
            />
          </div>
        </motion.div>
        <Link to="/#about" onClick={navigateHandler} className="more-info">
          <motion.button
            initial={{ opacity: 0 }}
            transition={{ delay: 9, duration: 2 }}
            animate={{ opacity: 1 }}
          >
            Find Out More
          </motion.button>
        </Link>
        <Triangle className="inverted-triangle" />
      </div>
    </div>
  );
};

export default Landing;
